<template>
	<div class="service-type-info-container">
		<mq-layout mq="desktop">
			<div class="destination-description truncate" aria-label="service type and locations">
				<a @click="setInitialModal" @keydown.enter="setInitialModal" class="location-link bold"
					title="show service type"
					:aria-label="`${serviceTypeName()}, at time ${getOrderTime}. Enter to change service type.`"
					tabindex="0">
					<span>{{ serviceTypeName() }}</span>
					<span v-if="orderTime">{{getOrderTime}}</span>
				</a>
				<template v-if="serviceType === EServiceType.SERVICE_TYPE_DELIVERY && address">
					to
					<a class="location-link bold" @click="setInitialModal" @keydown.enter="setInitialModal"
						title="change address"
						tabindex="0">
						{{address.formattedAddress.split(',')[0] || address.formattedAddress}}
					</a>
				</template>
				from
				<span>
					<a class="location-link bold" @click="showModal('locations')"  @keydown.enter="showModal('locations')"
						title="show store locations"
						:aria-label="`viewing store ${location.name}. Enter to open store locator.`"
						tabindex="0">
						{{location.name}}
					</a>
				</span>
			</div>
		</mq-layout>
		<mq-layout mq="mobile">
			<div class="destination-description">
				<div v-if="orderTime"  class="service-type-time">
					<a @click="showModal('OrderDetails')" class="location-link bold" title="show order times" tabindex="0">
						<span>{{ serviceTypeName() }}</span>
						{{getOrderTime}}
					</a>
				</div>
				<div class="service-type-location">
					<template v-if="serviceType === EServiceType.SERVICE_TYPE_DELIVERY && address">
						to
						<a @click="showModal('OrderDetails')" class="location-link bold" title="show store locations" tabindex="0">
							{{address.formattedAddress.split(',')[0] || address.formattedAddress}}
						</a>
					</template>
				</div>
			</div>
		</mq-layout>
	</div>
</template>

<script>
	import * as moment from "moment";
	import { EServiceType } from '@/models/interfaces/Orders/EServiceType';
	import { LOCATION, ACCOUNT_CHECKOUT, ACCOUNT } from '@/stores/defs';
	import { mapGetters, mapActions } from 'vuex';
	import ContentModal from "@ContentModal";
	import DateManipulator from '@/utils/DateManipulator';
	import InitialOrderSetup from "@/components/orders/initial-order-setup/InitialOrderSetup";
	import OrderDetails from '@/components/orders/OrderDetails';
	import StoreLocator from '@/components/store-locator/StoreLocator/StoreLocator';
	import modalMixin from '@Mixin/modalMixin';
	import serviceMixin from '@Mixin/serviceMixin';
	import navigationMixin from '@Mixin/navigationMixin';

	export default {
		mixins: [
			modalMixin,
			serviceMixin,
			navigationMixin,
		],
		computed: {
			...mapGetters({
				loggedIn: ACCOUNT.GET_LOGGED_IN,
				serviceType: ACCOUNT_CHECKOUT.GET_SERVICE_TYPE,
				location: LOCATION.GET_LOCATION,
				orderTime: ACCOUNT_CHECKOUT.GET_ORDER_TIME,
				deliveryAddress: ACCOUNT_CHECKOUT.GET_DELIVERY_ADDRESS,
				guestAddress: ACCOUNT.GET_GUEST_ADDRESS
			}),
			getOrderTime(time) {
				if (this.orderTime && DateManipulator.isTimeASAP(this.orderTime)) {
					return "ASAP"
				} else {
					const dateFormat = DateManipulator.isMomentToday(this.orderTime) ? "hh:mma" : "MM/DD/YYYY hh:mma";
					return moment(this.orderTime).format(dateFormat);
				}
			},
			address() {
				if (this.guestAddress) {
					return this.guestAddress;
				} else {
					return this.deliveryAddress;
				}
			}
		},
		data() {
			return {
				EServiceType: EServiceType,
			}
		},
		methods: {
			showModal(modalType) {
				if (this.$isMobile) {
					this._navigateToServiceChooser();
					return;
				}
				let component, title;
				if (modalType === "locations") {
					component = StoreLocator;
					title = "Locations";
				} else if (modalType === "OrderDetails") {
					component = InitialOrderSetup;
					title = "Choose a Location";
				}
				this.triggerModal({
					component: component,
					showCloseButton: true,
					classes: "global-modal",
					title: title
				})
			},
			setInitialModal() {
				const title = "How would you like your order?"
				if (this.loggedIn) {
					this.triggerModal({
						component: OrderDetails,
						showCloseButton: true,
						classes: "global-modal",
						title: title
					})
				} else {
					let title = null
					this.triggerModal({
						component: InitialOrderSetup,
						showCloseButton: true,
						classes: "global-modal",
						showCloseButton: true
					})
				}
			},
			isInjectable() {
				return (this.$route.name === "injectable-header");
			},
			serviceTypeName() {
				return this.resolveServiceName(this.getServiceType);
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import 'globalStyles';
	.destination-description {
		max-width: 33vw;
		a {
			&.location-link {
				color: $navigationItemColor;
			}
			&.bold {
				font-weight: bold;
			}
		}
	}
	@include mobile {
		.destination-description {
			text-align: center;
			max-width: 50vw;
		}
	}

</style>


// WEBPACK FOOTER //
// src/components/header/ServiceTypeInfo.vue